import { mapMutations, mapGetters, mapActions } from "vuex";
import { email, maxLength, minLength, required } from "vuelidate/lib/validators";
import { camelCase } from "lodash";

export default {
    name: "enter-form",
    data() {
        return {
            payload: {
                email: "",
                password: "",
            },
            validationErrors: {},
            inputValue: "",
        };
    },
    validations: {
        payload: {
            email: {
                required,
                maxLength: maxLength(50),
                email,
            },
            password: {
                required,
                minLength: minLength(8),
                maxLength: maxLength(20),
            },
        },
    },
    components: {},
    computed: {
        ...mapGetters({
            popupRegister: "auth/popupRegister",
            favouriteList: "favorites/whichList",
            singInLoading: "auth/singInEmailLoading",
        }),
        emailErrors() {
            let error = [];
            if (!this.$v.payload.email.$dirty) {
                return error;
            }
            if (!this.$v.payload.email.maxLength) {
                error.push(this.$t("validationMax") + " 50");
            }
            if (!this.$v.payload.email.required) {
                error.push(this.$t("validationRequired"));
            }
            if (!this.$v.payload.email.email) {
                error.push(this.$t("validationEmail"));
            }
            if (this.validationErrors.email) {
                this.validationErrors.email.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        passwordErrors() {
            let error = [];
            if (!this.$v.payload.password.$dirty) {
                return error;
            }
            if (!this.$v.payload.password.maxLength) {
                error.push(this.$t("validationMax") + " 30");
            }
            if (!this.$v.payload.password.required) {
                error.push(this.$t("validationRequired"));
            }
            if (!this.$v.payload.password.minLength) {
                error.push(this.$t("validationMin").replace(":count", 8));
            }
            if (this.validationErrors.password) {
                this.validationErrors.password.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        disableButton() {
            if (this.payload.email === "" || this.payload.password === "") {
                return true;
            }
            return false;
        },
    },
    methods: {
        ...mapActions({
            singIn: `auth/GET_TOKEN`,
            fetchUser: `profile/FETCH_USER_DATA`,
            fetchFavouriteList: `favorites/GET_FAVORITES_LIST`,
        }),
        ...mapMutations({
            changePopupRegister: `auth/CHANGE_POPUP_REGISTER`,
        }),
        submit() {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                this.singIn(this.payload)
                    .then(() => {
                        this.$toasted.success(this.$t("successAuth"));
                        if (this.popupRegister.isRedirect) {
                            this.$router.push({ name: "profile" }).catch(() => {
                                console.log();
                                this.fetchUser();
                                this.fetchFavouriteList();
                            });
                        }
                        this.changePopupRegister(false);
                    })
                    .catch(error => {
                        console.log(error);
                        if (error.response.status === 404) {
                            this.$toasted.error(this.$t("authDataFail"));
                        }
                        if (error.response.status === 418) {
                            // this.$toasted.error(error.response.data.message);
                            this.$toasted.error(this.$t("authFail"));
                            const errors = error.response.data.errors;
                            for (const i in errors) {
                                Vue.set(this.validationErrors, camelCase(i), errors[i]);
                                errors[i].forEach(e => {
                                    this.$toasted.error(this.$t("authFail"));
                                });
                            }
                        }
                        if (error.response.status === 422) {
                            this.$toasted.error(error.response.data.message);
                            const errors = error.response.data.errors;
                            for (const i in errors) {
                                Vue.set(this.validationErrors, camelCase(i), errors[i]);
                                errors[i].forEach(e => {
                                    this.$toasted.error(e);
                                });
                            }
                        }
                        if (error.response.status === 403) {
                            this.$toasted.error(this.$t("approvedAuth"));
                            const errors = error.response.data.errors;
                            for (const i in errors) {
                                Vue.set(this.validationErrors, camelCase(i), errors[i]);
                                errors[i].forEach(e => {
                                    this.$toasted.error(e);
                                });
                            }
                        }
                    });
            }
        },
        isLetter(e) {
            let char = String.fromCharCode(e.keyCode);
            if (/^[a-zA-Z0-9-а-яА-я-яєіїШЇЄІ@/.]*$/.test(char)) return true;
            else e.preventDefault();
        },
    },
};
